import type { FilterWidgetSettings } from "../../../../../api/types/dashboardsTypes";
import type { DashboardFilter } from "../../dashboard.types";
import { getReferenceDateValues } from "./settings/getDateLabel";

export const getFilterWidgetValues = (
  filter: DashboardFilter,
  settings: FilterWidgetSettings | undefined
): unknown[] => {
  if (filter.dataType !== "date") {
    return settings?.defaultValue ?? [];
  }
  if (settings?.referenceDate === undefined) {
    return [];
  }
  return getReferenceDateValues(settings.referenceDate, settings.defaultValue as string[]);
};
